import { Typography } from "@mui/material";
import { useTotalTreeWeights } from "services/hooks";
import styles from "./../checkout.module.scss";

const CallToAction = () => {   
  const calculation = useTotalTreeWeights(); 
  return (
    <div className={`${styles.cta} row justify-content-center`}>
      
      <div className="col-md-8">
        <Typography variant="h4" align="center">
          Great job in taking the first step! Your yearly carbon footprint is <strong>{calculation.carbonTonnes} Tonnes of CO<sub>2</sub></strong>. By planting <strong>{calculation.totalTrees} 🌳 trees</strong>, you'll offset this, boost biodiversity, and create jobs.
        </Typography>
        <Typography variant="body1" align="center">
          Let's dive deeper into your footprint details:
        </Typography>
      </div>
    </div>
  );
};
export default CallToAction;
